import {createEntityAdapter, createSlice} from "@reduxjs/toolkit"
import {Client} from "types/Client"
import {StoreState} from "store"
import {fetchClients} from "./fetchClients"
import {useSelector} from "react-redux"

export const clientAdapter = createEntityAdapter<Client>()

export interface StateProps {
    loading: boolean
    pagination: {
        total: number
    }
}

const initialState = clientAdapter.getInitialState<StateProps>({
    loading: true,
    pagination: {
        total: 0
    }
})

const clientSlice = createSlice({
    name: "client",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchClients.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchClients.fulfilled, (state, action) => {
            clientAdapter.removeAll(state)
            clientAdapter.setMany(state, action.payload?.data?.content)
            state.loading = false
            state.pagination.total = action?.payload?.data?.total_elements
        })
        builder.addCase(fetchClients.rejected, state => {
            state.loading = false
        })
    }
})

export const {selectById, selectAll} = clientAdapter.getSelectors<StoreState>(state => state.client)

// Загрузка
export const useLoadingClients = () => useSelector((state: StoreState) => state.client.loading)

export const useSelectPaginationClients = () => useSelector((state: StoreState) => state.client.pagination.total)
// Вывод всех сотрудников
export const useSelectAllClients = () => useSelector(selectAll)

export default clientSlice.reducer
